export var ALIGNMENT = {
  DEFAULT: 'default',
  LEADING: 'leading'
};